import React, { useState } from "react";
import { X } from "react-feather";
import { useIntl } from "react-intl";
import "./styles.scss";

const DeletionConfirmationModal = ({ onClose, onConfirmation }) => {
  const { formatMessage } = useIntl();
  const [isLoading, setIsLoading] = useState(false);

  function onClickHandler() {
    setIsLoading(true);
    onConfirmation();
  }

  return (
    <>
      <div className="modal confirmation-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "confirmar-relatorio-delecao" })}
            </div>
            <X
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <section className="modal-card-body">
            {formatMessage({ id: "confirmar-delecao" })}{" "}
          </section>
          <footer className="modal-card-foot">
            <button className="button" onClick={onClose}>
              {formatMessage({ id: "cancelar" })}
            </button>
            <button
              className={`button primary ${isLoading ? "is-loading" : ""}`}
              onClick={onClickHandler}
            >
              {formatMessage({ id: "continuar" })}
            </button>
          </footer>
        </div>
      </div>
    </>
  );
};

export default DeletionConfirmationModal;
